/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcSDDCInfo } from './vmcSDDCInfo';


export interface VmcOrgInfo { 
    /**
     * Time at which org was created
     */
    created_at: string;
    /**
     * User who created org
     */
    created_by: string;
    /**
     * AWS region list which are enabled in given org
     */
    enabled_regions: string;
    /**
     * Org UUID
     */
    org_id: string;
    /**
     * Org Name
     */
    org_name: string;
    /**
     * Internal vs Customer orgs (value controlled by VMC service)
     */
    org_type: string;
    sddcs: Array<VmcSDDCInfo>;
    /**
     * AWS Account number for VMC shadow account
     */
    shadow_account: string;
}

